<template>
  <div class="bindRole">
    <mt-header :title="$t('绑定角色')" class="dl_header_white" fixed>
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>
    <div class="content_field">
      <div @click="showServerList = true">
        <mt-field
            :label="$t('服务区')"
            :placeholder="$t('请选择服务区')"
            class="info"
            v-model="serverValue"
        ></mt-field>
      </div>
      <div @click="showRoleListPopup()">
        <mt-field
            :label="$t('角色')"
            :placeholder="$t('请选择角色')"
            class="info"
            v-model="roleValue"
        ></mt-field>
      </div>

      <mt-button type="primary" size="large" class="bindBtn" @click="bindRole()">{{ $t('绑定') }}</mt-button>
    </div>
    <mt-popup v-model="showServerList" position="bottom" modal="false" class="gameArea">
      <div class="search">
        <svg t="1639730657475" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2034" width="20" height="20"><path d="M945.066667 898.133333l-189.866667-189.866666c55.466667-64 87.466667-149.333333 87.466667-241.066667 0-204.8-168.533333-373.333333-373.333334-373.333333S96 264.533333 96 469.333333 264.533333 842.666667 469.333333 842.666667c91.733333 0 174.933333-34.133333 241.066667-87.466667l189.866667 189.866667c6.4 6.4 14.933333 8.533333 23.466666 8.533333s17.066667-2.133333 23.466667-8.533333c8.533333-12.8 8.533333-34.133333-2.133333-46.933334zM469.333333 778.666667C298.666667 778.666667 160 640 160 469.333333S298.666667 160 469.333333 160 778.666667 298.666667 778.666667 469.333333 640 778.666667 469.333333 778.666667z" p-id="2035"></path></svg>
        <input v-model="inputSValue" class="inp" type="text" placeholder="search" @input="getList">
      </div>
      <div class="list">
        <div class="item" v-for="(item,index) in serverList" :key="index" @click="onClick(item)">
          <div class="title">{{ item.name }}</div>
          <div class="value">{{ item.sid }}</div>
        </div>
      </div>
    </mt-popup>
    <mt-popup v-model="showRoleList" position="bottom" modal="false" class="gameArea">
      <div class="search">
        <svg t="1639730657475" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2034" width="20" height="20"><path d="M945.066667 898.133333l-189.866667-189.866666c55.466667-64 87.466667-149.333333 87.466667-241.066667 0-204.8-168.533333-373.333333-373.333334-373.333333S96 264.533333 96 469.333333 264.533333 842.666667 469.333333 842.666667c91.733333 0 174.933333-34.133333 241.066667-87.466667l189.866667 189.866667c6.4 6.4 14.933333 8.533333 23.466666 8.533333s17.066667-2.133333 23.466667-8.533333c8.533333-12.8 8.533333-34.133333-2.133333-46.933334zM469.333333 778.666667C298.666667 778.666667 160 640 160 469.333333S298.666667 160 469.333333 160 778.666667 298.666667 778.666667 469.333333 640 778.666667 469.333333 778.666667z" p-id="2035"></path></svg>
        <input v-model="inputRValue" class="inp" type="text" placeholder="search" @input="getRList">
      </div>
      <div class="list">
        <div class="item" v-for="(item,index) in roleList" :key="index" @click="onClickRole(item)">
          <div class="title">{{ item.name }}</div>
          <div class="value">{{ item.charId }}</div>
        </div>
      </div>
    </mt-popup>
  </div>

</template>

<script>
import {Popup, Toast} from "mint-ui";
import { httpPostServerList, httpPostRoleList, httpPostBindRole } from '@/api/game'
export default {
  name: "BindRole",
  data() {
    return {
      coin_id:this.$route.query.coin_id,
      serverValue: '',
      inputSValue:'',
      roleValue: '',
      inputRValue:'',
      serverList: [],
      roleList: [],
      showServerList: false,
      showRoleList: false,
      chooseServerValue:''
    }
  },
  created() {
    this.getServerList()
  },
  methods: {
    getServerList(){
      httpPostServerList({coin_id:this.coin_id}).then(res => {
        this.serverList = res.data
      }).catch()
    },
    getRoleList(coin_id,sid){
      httpPostRoleList({coin_id:coin_id,sid:sid}).then(res => {
        this.roleList = res.data
      }).catch()
    },
    goback: function () {
      this.$router.back();
    },
    getList(){
      if(this.inputSValue == ''){
        this.getServerList()
      }else{
        this.serverList = this.serverList.filter(
            item =>{
              return item.name.includes(this.inputSValue) ||
                  item.sid.toString().includes(this.inputSValue)
            }
        )
      }
    },
    getRList(){
      if(this.inputRValue == ''){
        this.getRoleList(this.coin_id,this.chooseServerValue)
      }else{
        this.roleList = this.roleList.filter(
            item =>{
              return item.name.includes(this.inputRValue) ||
                  item.charId.toString().includes(this.inputRValue)
            }
        )
      }
    },
    onClick(item) {
      this.$emit('onChange', item.name)
      this.serverValue = item.name
      this.inputSValue = ''
      this.showServerList = false
      this.chooseServerValue = item.sid
      this.getList()
      this.getRoleList(this.coin_id,item.sid)
    },
    showRoleListPopup(){
      if(this.chooseServerValue == ''){
        Toast(this.$t("请先选择服务区"));
      }else{
        this.showRoleList = true
      }
    },
    onClickRole(item) {
      this.$emit('onChange', item.name)
      this.roleValue = item.name
      this.inputRValue = ''
      this.char_id = item.charId
      this.showRoleList = false
      this.getRList()
    },
    bindRole(){
      if(this.serverValue == ''){
        Toast(this.$t("请先选择服务区"));
      }else if (this.roleValue == ''){
        Toast(this.$t("请先选择角色"));
      }else{
        let params = {
          coin_id:this.coin_id,
          sid:this.chooseServerValue,
          char_id:this.char_id,
          server_name:this.serverValue,
          role_name:this.roleValue,
        }
        httpPostBindRole(params).then(res => {
          Toast(this.$t("绑定成功"));
          this.goback()
        }).catch(e => {
        })
      }
    }
  }
}
</script>

<style scoped>
.bindRole{
  height: calc( 100vh - 40px);
}
.content_field{
  margin: 45px 10px 15px;
}
.info{
  border-bottom: solid 1px #eaeaea;
}
.bindBtn{
  margin-top: 15px;
  background: #1296DB;
}
.gameArea{
  width: 100%;
  height: 70%;
}
.wrap {
  /*width: 100vh;*/
  width: 100%;
  height: 80vh;
  overflow: hidden;
}
.search {
  display: flex;align-items: center;
  background-color: #fff;
  border: 8px solid #f2f2f2;
  padding: 5px;
}
.search .inp {
  flex: 1;
  padding-left: 10px;
  background-color: transparent;
  line-height: 25px;height: 25px;
}
.list {
  width: 100%;bottom: 0;
  overflow: scroll;
  height: calc(100% - 51px);
}
.item{
  display: flex;justify-content: space-between;align-items: center;
  padding: 10px;
}
.value {
  font-size: 15px;
  color: #888;
}
/deep/ .mint-cell-text {
  margin-left: 0;
}
.item {
  display: flex;justify-content: space-between;align-items: center;
  padding: 10px;
}
.value {
  font-size: 15px;
  color: #888;
}
.dl_margin4_top{
  margin-top: 0;
}
/deep/ .mint-field .mint-cell-title {
  width: 70px !important;
  font-size: 14px;
}
/deep/ .mint-field .mint-cell-value{
  font-size: 14px;
}
</style>
